import React, { useEffect } from "react";
import Table from "./Table";

const UjiSilangFaskesSlidePositif = () => {
  useEffect(() => {
    document.title = "SISMAL | Uji Silang Fasyankes";
  }, []);

  return (
    <div className="dashboard-wrapper">
      <Table />
    </div>
  );
};

export default UjiSilangFaskesSlidePositif;
